<template>
  <div class="ring-container">
    <div class="gem-container">
      <font-awesome-icon v-bind:icon="gemIcon"></font-awesome-icon>
    </div>
    <div class="weight-container">
      <p>{{ weight | weightFormat }} гр</p>
    </div>
    <div class="borders"></div>
    <div class="caption">
      <div class="caption-line"></div>
      <div class="caption-text">
        <span>Размер</span>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGem } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'RingsCalculatorOutputWeight',
  props: {
    weight: { type: Number }
  },
  components: { FontAwesomeIcon },
  data () {
    return {
      gemIcon: faGem
    }
  },
  filters: {
    weightFormat (value) {
      return value.toFixed(2)
    }
  }
}
</script>

<style scoped lang="scss">
  $container-size: 120px;
  $gem-size: 20px;
  $caption-margin: 5px;

  .ring-container {
    width: $container-size;
    position: relative;

    & > .gem-container {
      width: $container-size;
      height: $gem-size;
      text-align: center;
      font-size: $gem-size;
      color: $default-link-color;
    }

    & > .weight-container {
      width: $container-size;
      height: $container-size;

      display: flex;
      justify-content: center;
      align-items: center;

      border: 3px solid $default-link-color;
      border-radius: 50%;
      box-sizing: border-box;

      color: $default-link-color;
      font-family: "Century Gothic", $font-stack;
      font-size: 1.5em;
      position: relative;
      z-index: 2;

      & > p { margin: 0; }
    }
    & > .borders {
      width: $container-size;
      height: $container-size / 2 + $caption-margin;
      position: absolute;
      top: $container-size / 2 + $gem-size;
      left: 0;
      border-left: 1px solid $default-text-color;
      border-right: 1px solid $default-text-color;
      box-sizing: border-box;
      z-index: 1;
    }
    & > .caption {
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      height: $gem-size;
      width: 100%;
      margin-top: $caption-margin;
      border-left: 1px solid $default-text-color;
      border-right: 1px solid $default-text-color;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 2;

      & > .caption-line {
        position: absolute;
        width: 100%;
        z-index: 1;
        border-top: 1px solid $default-text-color;
        top: 50%;
      }
      & > .caption-text {
        position: relative;
        z-index: 2;
        & > span {
          background-color: $content-background-color;
          padding: 0 0.5em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/RingsCalculatorOutputWeight.vue